import { connect } from 'react-redux';
import { compose, lifecycle, withPropsOnChange } from 'recompose';
import { mapCostsBreakdownConfig, mapCost, mapStampDutyCost } from '../../../helpers/components/costs-brekdown';
import { getFAQ } from '../../../store/reducers/faq';
import { withLoadingHandlers, withSpinner } from '../../../components/with-loader';
import { CostsBreakdownComponent } from './component';

const FAQ_KEY = 'FAQBreakdown';

export const CostsBreakdownContainer = compose(
  connect(
    ({ userAttributes, faq }, { goals, configuration }) => {
      const { FAQGroup } = configuration;

      return {
        goals: goals ?? mapCostsBreakdownConfig(userAttributes.goal),
        faq: faq.questions[FAQGroup]
      };
    },
    { getFAQ }
  ),
  withPropsOnChange(['goals'], ({ goals, configuration }) => {
    const {
      DISPLAY_COMPONENTS: { STAMP_DUTY }
    } = window.CONFIG;

    return {
      items: [
        mapCost({ attrKey: 'depositAmount', dataKey: 'depositBuilderLink', goals, configuration }),
        ...(STAMP_DUTY ? [mapStampDutyCost(goals, configuration)] : []),
        mapCost({ attrKey: 'legalFees', dataKey: 'legalFeesLink', goals, configuration }),
        mapCost({ attrKey: 'misc', dataKey: 'homeBuyingCost', goals, configuration })
      ].sort((a, b) => (a.weight = b.weight))
    };
  }),
  withLoadingHandlers(true),
  lifecycle({
    async componentDidMount() {
      const { getFAQ, turnOffLoading } = this.props;

      await getFAQ({ name: FAQ_KEY, normalize: 'key' });

      turnOffLoading();
    }
  }),
  withSpinner
);
export const CostsBreakdown = CostsBreakdownContainer(CostsBreakdownComponent);
